import { cn } from "@/lib/utils";

const FrameworkBadge = ({ framework, className }) => (
  <span
    className={cn(
      "inline-flex items-center rounded-md border border-secondary/30 bg-secondary/10 px-2.5 py-1 text-xs text-foreground shrink-0",
      className,
    )}
  >
    {framework}
  </span>
);

export default FrameworkBadge;
